// Must be the first import of the entry point. CRA builds with publicPath "/",
// but the plugin lives under wp-content/plugins/..., so bundled assets
// (e.g. hero images) would otherwise 404. WordPress localizes the real build
// URL before this bundle loads.
/* eslint-disable camelcase, no-undef */
if (window.dreamfox_wdd_params && window.dreamfox_wdd_params.buildUrl) {
  __webpack_public_path__ = window.dreamfox_wdd_params.buildUrl
}
